(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sns-advent-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function clamp(value) { return Math.min(1, Math.max(0, value)); }
  function progress(top, height, viewport) { return clamp((viewport * 0.25 - top) / Math.max(1, height * 0.85)); }
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var section = root.closest('.sns-advent-hero');
    var video = root.querySelector('video');
    var button = root.querySelector('button');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var hasObserver = 'IntersectionObserver' in window;
    var near = !hasObserver, scrolled = false, manualPause = false, loaded = false, ready = false, failed = false, destroyed = false;
    var frame = 0, target = 0, initialY = window.scrollY, seeking = false, lastRequested = null;
    function limited() { return reduced.matches || (connection && connection.saveData); }
    function label() { button.textContent = manualPause ? button.dataset.resume : button.dataset.pause; button.setAttribute('aria-pressed', String(manualPause)); }
    function canSeek() { return !destroyed && !failed && !limited() && !manualPause && near && !document.hidden; }
    function seek() {
      if (!ready || !canSeek() || seeking || video.seeking) return;
      if ((lastRequested !== null && Math.abs(lastRequested - target) < 1 / 24) || Math.abs(video.currentTime - target) < 1 / 24) { if (video.readyState >= 2) root.dataset.videoReady = 'true'; return; }
      seeking = true;
      try { lastRequested = target; video.currentTime = target; } catch (error) { seeking = false; lastRequested = null; }
    }
    function measure() {
      frame = 0;
      if (destroyed) return;
      var still = limited() || failed;
      root.toggleAttribute('data-static', !!still);
      button.hidden = !loaded || !!still;
      var rect = section.getBoundingClientRect();
      if (!hasObserver) near = rect.top < window.innerHeight + 150 && rect.top + rect.height > -150;
      if (!canSeek() || !scrolled) return;
      if (!loaded) {
        loaded = true;
        video.preload = 'auto';
        video.src = video.dataset.src;
        video.load();
        button.hidden = false;
      }
      var end = Number.isFinite(video.duration) ? Math.max(0, video.duration - 1 / 24) : 0;
      target = progress(rect.top, rect.height, window.innerHeight) * end;
      seek();
    }
    function schedule() { if (!destroyed && !frame) frame = window.requestAnimationFrame(measure); }
    function scroll() { if (Math.abs(window.scrollY - initialY) > 2) scrolled = true; schedule(); }
    function metadata() { ready = Number.isFinite(video.duration) && video.duration > 0; schedule(); }
    function seeked() { seeking = false; if (ready && video.readyState >= 2) root.dataset.videoReady = 'true'; seek(); }
    function toggle() { manualPause = !manualPause; label(); schedule(); }
    function error() { failed = true; root.dataset.videoReady = 'false'; schedule(); }
    function hide() { if (frame) window.cancelAnimationFrame(frame); frame = 0; }
    button.addEventListener('click', toggle);
    video.addEventListener('loadedmetadata', metadata);
    video.addEventListener('loadeddata', metadata);
    video.addEventListener('seeked', seeked);
    video.addEventListener('error', error);
    window.addEventListener('scroll', scroll, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    window.addEventListener('pagehide', hide);
    window.addEventListener('pageshow', schedule);
    document.addEventListener('visibilitychange', schedule);
    reduced.addEventListener('change', schedule);
    if (connection && connection.addEventListener) connection.addEventListener('change', schedule);
    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) { near = entries[0].isIntersecting; schedule(); }, {rootMargin:'150px 0px',threshold:0});
      observer.observe(section);
    }
    function unload(event) {
      if (!event.target.contains(root)) return;
      destroyed = true; hide();
      if (observer) observer.disconnect();
      window.removeEventListener('scroll', scroll); window.removeEventListener('resize', schedule);
      window.removeEventListener('pagehide', hide); window.removeEventListener('pageshow', schedule);
      document.removeEventListener('visibilitychange', schedule);
      reduced.removeEventListener('change', schedule);
      if (connection && connection.removeEventListener) connection.removeEventListener('change', schedule);
      button.removeEventListener('click', toggle);
      video.removeEventListener('loadedmetadata', metadata); video.removeEventListener('loadeddata', metadata); video.removeEventListener('seeked', seeked); video.removeEventListener('error', error);
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
    label(); schedule();
  }
  function scan(scope) { scope.querySelectorAll('[data-sns-advent-scroll]').forEach(init); }
  scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sns-ella-hero"] && !Shopify.designMode) return;
  try {
    
(function (global) {
  'use strict';
  function createScrollLock(doc, win) {
    var saved = null;
    var options = { passive: false, capture: true };
    var keys = [' ', 'Spacebar', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'PageUp', 'PageDown', 'Home', 'End'];
    function prevent(event) {
      if (!saved || !event.cancelable || event.ctrlKey) return;
      event.preventDefault();
    }
    function preventKey(event) {
      if (saved && event.cancelable && !event.ctrlKey && !event.altKey && !event.metaKey && keys.indexOf(event.key) !== -1) event.preventDefault();
    }
    function remember(element, property, value) {
      saved.styles.push({ element: element, property: property, value: element.style.getPropertyValue(property), priority: element.style.getPropertyPriority(property) });
      element.style.setProperty(property, value, 'important');
    }
    function restore(item) {
      if (item.value) item.element.style.setProperty(item.property, item.value, item.priority);
      else item.element.style.removeProperty(item.property);
    }
    function lock() {
      if (saved || !doc.body) return;
      var rect = doc.body.getBoundingClientRect();
      saved = { x: win.scrollX, y: win.scrollY, styles: [] };
      remember(doc.documentElement, 'scroll-behavior', 'auto');
      remember(doc.documentElement, 'overflow-x', 'hidden');
      remember(doc.documentElement, 'overflow-y', 'hidden');
      remember(doc.documentElement, 'overscroll-behavior-x', 'none');
      remember(doc.documentElement, 'overscroll-behavior-y', 'none');
      remember(doc.body, 'position', 'fixed');
      remember(doc.body, 'top', rect.top + 'px');
      remember(doc.body, 'left', rect.left + 'px');
      remember(doc.body, 'right', 'auto');
      remember(doc.body, 'bottom', 'auto');
      remember(doc.body, 'width', rect.width + 'px');
      remember(doc.body, 'max-width', 'none');
      remember(doc.body, 'margin-top', '0');
      remember(doc.body, 'margin-right', '0');
      remember(doc.body, 'margin-bottom', '0');
      remember(doc.body, 'margin-left', '0');
      remember(doc.body, 'box-sizing', 'border-box');
      doc.addEventListener('touchmove', prevent, options);
      doc.addEventListener('wheel', prevent, options);
      doc.addEventListener('keydown', preventKey, true);
    }
    function unlock() {
      if (!saved) return;
      var old = saved; saved = null;
      doc.removeEventListener('touchmove', prevent, options);
      doc.removeEventListener('wheel', prevent, options);
      doc.removeEventListener('keydown', preventKey, true);
      for (var i = old.styles.length - 1; i >= 1; i--) restore(old.styles[i]);
      win.scrollTo(old.x, old.y);
      restore(old.styles[0]);
    }
    return { lock: lock, unlock: unlock, isLocked: function () { return saved !== null; } };
  }
  var api = { createScrollLock: createScrollLock };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else global.EllaScrollLock = api;
})(typeof window !== 'undefined' ? window : globalThis);


(function (global) {
  'use strict';
  function clamp(value, low, high) { return Math.max(low, Math.min(high, value)); }
  function targetTime(position, range) {
    position = clamp(Number.isFinite(position) ? position : 0, -1, 1);
    return position < 0 ? range.front + position * (range.front - range.left)
      : range.front + position * (range.right - range.front);
  }
  function validRange(range, duration) {
    return Number.isFinite(duration) && duration > 0 && range &&
      [range.left, range.front, range.right].every(Number.isFinite) &&
      range.left >= 0 && range.left < range.front &&
      range.front < range.right && range.right < duration;
  }
  function createVideoScrubber(video, options) {
    var range = options.range, normalized = 0, waiting = false, ready = false;
    var disposed = false, failed = false, shown = false, seekCount = 0;
    var tolerance = options.tolerance || 1 / 60;
    function show() { if (disposed || failed || !ready) return; if (!shown) { shown = true; if (options.onReady) options.onReady(); } }
    function fail(reason) { failed = true; waiting = false; if (options.onError) options.onError(reason); }
    function drain() {
      if (disposed || failed || !ready || waiting || video.seeking) return;
      var time = targetTime(normalized, range);
      if (Math.abs(video.currentTime - time) <= tolerance) { show(); return; }
      waiting = true;
      try { video.currentTime = time; seekCount++; }
      catch (error) { fail(error); }
    }
    function loaded() {
      if (!validRange(range, video.duration)) { fail(new Error('Unverified video frame range')); return; }
      video.pause(); ready = true; drain();
    }
    function sought() { waiting = false; show(); drain(); }
    function errored() { fail(new Error('Video could not be loaded')); }
    video.muted = true; video.playsInline = true; video.preload = 'auto';
    video.addEventListener('loadeddata', loaded);
    video.addEventListener('seeked', sought);
    video.addEventListener('error', errored);
    if (video.readyState >= 2) loaded();
    return {
      setPosition: function (position) { normalized = clamp(Number.isFinite(position) ? position : 0, -1, 1); drain(); },
      reset: function () { normalized = 0; drain(); },
      state: function () { return { ready: ready, shown: shown, failed: failed, waiting: waiting, target: ready ? targetTime(normalized, range) : null, seekCount: seekCount }; },
      destroy: function () {
        disposed = true; video.pause();
        video.removeEventListener('loadeddata', loaded);
        video.removeEventListener('seeked', sought);
        video.removeEventListener('error', errored);
      }
    };
  }
  var api = { targetTime: targetTime, validRange: validRange, createVideoScrubber: createVideoScrubber };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else global.EllaVideoScrubber = api;
})(typeof window !== 'undefined' ? window : globalThis);

(function(){
 'use strict';
 var root=document.getElementById('ella-home-hero');
 if(!root||root.dataset.initialized) return;
 root.dataset.initialized='true';
 var labels=JSON.parse(root.querySelector('[data-eh-copy]').textContent);
 var treat=root.querySelector('.eh-treat'), dock=root.querySelector('.eh-treat-dock'), video=root.querySelector('.eh-video'), portrait=root.querySelector('.eh-portrait');
 var headingFirst=root.querySelector('.eh-heading-first'),headingAccent=root.querySelector('.eh-heading-accent'),copy=root.querySelector('.eh-description'),cta=root.querySelector('.eh-cta');
 var activePointer=null,keyboard=false,dragged=false,engaged=false,startX=0,startY=0,x=0,y=0,targetX=0,targetY=0;
 var scrollLock=EllaScrollLock.createScrollLock(document,window),lockedViewport=null;
 function viewport(){return {w:window.innerWidth,h:window.innerHeight,vh:window.visualViewport?window.visualViewport.height:window.innerHeight,scale:window.visualViewport?window.visualViewport.scale:1};}
 function lockPage(){if(!scrollLock.isLocked())lockedViewport=viewport();scrollLock.lock();root.dataset.scrollLocked=String(scrollLock.isLocked());}
 function unlockPage(){scrollLock.unlock();lockedViewport=null;root.dataset.scrollLocked='false';}
 function viewportChanged(){if(!lockedViewport||!(activePointer!==null||keyboard))return;var v=viewport();if(v.w!==lockedViewport.w||v.h!==lockedViewport.h||Math.abs(v.vh-lockedViewport.vh)>1||v.scale!==lockedViewport.scale)release(true);}
 var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');

 var footage={src:'https://cdn.shopify.com/videos/c/o/v/2b25a91f91b447418bc8766b3171a5cc.mp4',range:{left:0.2,front:8.5,right:19.7}};
 var videoScrubber=null;
 function startVideo(){if(videoScrubber||!footage.src||reduced.matches)return;
  videoScrubber=EllaVideoScrubber.createVideoScrubber(video,{range:footage.range,
   onReady:function(){portrait.dataset.videoReady=String(!reduced.matches);root.dataset.videoState='ready';},
   onError:function(){portrait.dataset.videoReady='false';root.dataset.videoState='error';}
  });
  root.dataset.videoState='loading';video.src=footage.src;video.load();
 }
 var videoObserver=null;
 if('IntersectionObserver' in window){videoObserver=new IntersectionObserver(function(entries){if(entries.some(function(e){return e.isIntersecting;})){startVideo();videoObserver.disconnect();}},{rootMargin:'300px'});videoObserver.observe(root);}else startVideo();
 reduced.addEventListener('change',function(){
  if(reduced.matches){portrait.dataset.videoReady='false';if(videoScrubber)videoScrubber.reset();}
  else {startVideo();if(videoScrubber&&!videoScrubber.state().failed)portrait.dataset.videoReady=String(videoScrubber.state().shown);}
 });
 function clamp(v,lo,hi){ return Math.max(lo,Math.min(hi,v)); }
 function position(){ treat.style.setProperty('--treat-x',x+'px'); treat.style.setProperty('--treat-y',y+'px'); }
 function home(){ var r=root.getBoundingClientRect(),d=dock.getBoundingClientRect(); x=d.left-r.left+(d.width-treat.offsetWidth)/2; y=d.top-r.top+(d.height-treat.offsetHeight)/2; position(); targetX=targetY=0; animate(); }
 function engage(){ startVideo();if(engaged)return; engaged=true; root.dataset.engaged='true'; headingFirst.textContent=labels.engaged_first; headingAccent.textContent=labels.engaged_accent; copy.textContent=labels.engaged_description; cta.hidden=false; }
 function aim(){ var r=root.getBoundingClientRect(),p=portrait.getBoundingClientRect(); var eyeX=p.left-r.left+p.width*.5,cx=x+treat.offsetWidth/2,delta=cx-eyeX; var span=delta<0?eyeX-treat.offsetWidth/2:r.width-eyeX-treat.offsetWidth/2;targetX=clamp(delta/Math.max(1,span),-1,1);animate(); }
 function animate(){ if(videoScrubber&&!reduced.matches)videoScrubber.setPosition(targetX); }
 function moveTo(cx,cy){var r=root.getBoundingClientRect();x=clamp(cx-r.left-treat.offsetWidth/2,4,r.width-treat.offsetWidth-4);y=clamp(cy-r.top-treat.offsetHeight/2,4,r.height-treat.offsetHeight-4);position();aim();}
 function release(cancel){var pointer=activePointer;activePointer=null;keyboard=false;treat.setAttribute('aria-pressed','false');if(pointer!==null){try{if(treat.hasPointerCapture(pointer))treat.releasePointerCapture(pointer);}catch(e){}}unlockPage();if(cancel||!dragged)home();}
 treat.addEventListener('pointerdown',function(e){if(e.button!==0||e.isPrimary===false||activePointer!==null)return;e.preventDefault();treat.focus({preventScroll:true});activePointer=e.pointerId;keyboard=false;dragged=false;startX=e.clientX;startY=e.clientY;try{treat.setPointerCapture(e.pointerId);}catch(error){release(true);return;}lockPage();treat.setAttribute('aria-pressed','true');});
 treat.addEventListener('pointermove',function(e){if(e.pointerId!==activePointer)return;if(e.cancelable)e.preventDefault();if(!dragged&&Math.hypot(e.clientX-startX,e.clientY-startY)>4){dragged=true;engage();}if(dragged)moveTo(e.clientX,e.clientY);});
 treat.addEventListener('pointerup',function(e){if(e.pointerId===activePointer)release(false);});
 treat.addEventListener('pointercancel',function(e){if(e.pointerId===activePointer)release(true);});
 treat.addEventListener('lostpointercapture',function(){if(activePointer!==null)release(true);});
 treat.addEventListener('dragstart',function(e){e.preventDefault();});
 treat.addEventListener('keydown',function(e){
  if(e.key==='Escape'){e.preventDefault();release(true);return;}
  if(e.key==='Enter'||e.key===' '){e.preventDefault();keyboard=!keyboard;treat.setAttribute('aria-pressed',String(keyboard));if(keyboard){lockPage();dragged=true;engage();aim();}else unlockPage();return;}
  if(keyboard&&['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].indexOf(e.key)>-1){e.preventDefault();var n=e.shiftKey?48:24;x=clamp(x+(e.key==='ArrowRight'?n:e.key==='ArrowLeft'?-n:0),4,root.clientWidth-treat.offsetWidth-4);y=clamp(y+(e.key==='ArrowDown'?n:e.key==='ArrowUp'?-n:0),4,root.clientHeight-treat.offsetHeight-4);position();aim();}
 });
 treat.addEventListener('blur',function(){if(keyboard)release(false);});
 root.querySelector('.eh-reset').addEventListener('click',function(){release(true);engaged=false;root.dataset.engaged='false';headingFirst.textContent=labels.initial_first;headingAccent.textContent=labels.initial_accent;copy.textContent=labels.description;cta.hidden=true;home();treat.focus({preventScroll:true});});
 window.addEventListener('resize',viewportChanged);
 if(window.visualViewport)window.visualViewport.addEventListener('resize',viewportChanged);
 window.addEventListener('keydown',function(e){if(e.key==='Escape'&&(activePointer!==null||keyboard)){e.preventDefault();release(true);}});
 window.addEventListener('pagehide',function(){release(true);});
 window.addEventListener('blur',function(){if(activePointer!==null||keyboard)release(true);});
 document.addEventListener('visibilitychange',function(){if(document.hidden&&(activePointer!==null||keyboard))release(true);});
 var previousSize='';var ro=new ResizeObserver(function(){var size=root.clientWidth+'x'+root.clientHeight;if(size===previousSize)return;previousSize=size;release(true);home();});ro.observe(root);
 document.addEventListener('shopify:section:unload',function(e){if(e.target.contains(root)){release(true);ro.disconnect();if(videoObserver)videoObserver.disconnect();if(videoScrubber)videoScrubber.destroy();}});
 home();
})();

  } catch(e) { console.error(e); }
})();
})();
